<template>
  <div>
      <div :id="id" :style="{ height: '149px',width:'100%'}"></div>
  </div>
</template>

<script>
/**
 * dataset数组格式为：[{count: '***', color: '***'}],count是数量，color是对应类目的颜色
 * 因为展示主要是颜色和数值就好，所以关键是这两个
 */
import echarts from "echarts";

export default {
  name: 'dashboardChart',
  props: {
     dataset: {
      type: Array,
      default: function() {
        return [];
      },
    },
    title: {
      type: String,
      default: '总评价数'
    }
  },
   data() {
    return {
      chartData: [],
      id: "echarts_" + new Date().getTime() + Math.floor(Math.random() * 1000),
	    processingSatisfactionEcharts: null
    };
  },
  created() {
    this.chartData = this._.cloneDeep(this.dataset)
    console.log('created', this.chartData);
  },
  mounted() {
	  // this.processingSatisfactionEcharts = echarts.init(
		//   document.getElementById(this.id)
	  // );
    this.drawLine();
    console.log('mounted', this.chartData);

  },
   watch: {
    dataset(newValue, oldValue) {
      this.chartData = newValue;
      // this.drawLine();
      // if(newValue.length == 0 || newValue[0].source == null ||newValue[0].source.length == 0){
      // if(newValue.length == 0){
      // this.chartData = [{ count: 1, color: '#dcdde0' }]
      // }else{
      // }
    },
  },
  methods: {
    drawLine() {
      	  this.processingSatisfactionEcharts = echarts.init(
		  document.getElementById(this.id)
	  );
        const data = []
        let total = 0
        let num = 0;
        // 取总数
        this.chartData.map(i => {
          i.count = Number(i.count)
          total += i.count
        })
        // 数组升序
        this.chartData.sort((a, b) => {
          return a.count - b.count
        })
        // 取最后一个作为百分百
        const lastObj = this.chartData[this.chartData.length - 1]

        // console.log(total, data);
        if (total === 0) {
          data.push([1, "#f9fafc"])
        } else if (this.chartData.length > 0) {
          this.chartData.map((i, index) => {
            // 如果不是最后一个则添加到数组
            if (index !== this.chartData.length - 1) {
	            num += i.count;
              data.push([num / total, i.color])
            }
          })
          data.push([1, lastObj.color])
        }
        const option = {
          title: {
            x: 'center',
            text: this.title,
            textStyle: {
              fontSize: 12,
              fontWeight: 400,
              color: '#71747A',
              fontFamily: 'PingFangSC-Regular'
            },
            y: 'center',
            subtext: `${total} 起`,
            subtextStyle: {
              fontSize: 16,
              fontWeight: 'Bold',
              color: '#1E2226',
              fontFamily: 'PingFangSC-Regular'
            }
          },
        series: [
          {
            name: "设备利用率",
            type: "gauge",
            radius: "100%",
            center: ["50%", "60%"], // 默认全局居中
            axisLine: {
              // 坐标轴线
              lineStyle: {
                // 属性lineStyle控制线条样式
                width: 12,
                color: data
              }
            },
            axisTick: {
              show: false,
              // 坐标轴小标记
              length: 0, // 属性length控制线长
              lineStyle: {
                // 属性lineStyle控制线条样式
                color: "auto"
              }
            },
            axisLabel: {
              show: false
            },
            splitLine: {
              show: false,
              // 分隔线
              length: 0, // 属性length控制线长
              lineStyle: {
                // 属性lineStyle（详见lineStyle）控制线条样式
                color: "red"
              }
            },
            detail: { show: false },
          }
          ]
        }
        this.processingSatisfactionEcharts.setOption(option);
    }
  },
}
</script>
